import React from "react";
import styles from "./Toast.module.css";

interface ToastProps {
  isVisible: boolean;
  message?: string;
}

export const Toast: React.FC<ToastProps> = ({
  isVisible,
  message = "Спасибо за помощь!\nМы учтем уточнение",
}) => {
  if (!isVisible) return null;

  return (
    <div className={styles.toast}>
      <div className={styles.content}>
        <div className={styles.iconContainer}>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.8979 14.2497C15.5026 14.9335 14.9343 15.5013 14.2501 15.896C13.5659 16.2908 12.7899 16.4986 12 16.4986C11.2101 16.4986 10.4341 16.2908 9.74993 15.8961C9.06574 15.5013 8.49743 14.9335 8.10205 14.2497M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
              stroke="#7E64FF"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M8.625 11.25C9.24632 11.25 9.75 10.7463 9.75 10.125C9.75 9.50368 9.24632 9 8.625 9C8.00368 9 7.5 9.50368 7.5 10.125C7.5 10.7463 8.00368 11.25 8.625 11.25Z"
              fill="#7E64FF"
            />
            <path
              d="M15.375 11.25C15.9963 11.25 16.5 10.7463 16.5 10.125C16.5 9.50368 15.9963 9 15.375 9C14.7537 9 14.25 9.50368 14.25 10.125C14.25 10.7463 14.7537 11.25 15.375 11.25Z"
              fill="#7E64FF"
            />
          </svg>
        </div>
        <div className={styles.messageContainer}>
          <div className={styles.message}>{message}</div>
        </div>
      </div>
    </div>
  );
};
